import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { tabs } from 'src/app/dummy/tabs';
import { PrintService } from 'src/app/services/print.service';
import { Environment } from 'src/app/stores/environment.store';
import { Report } from 'src/app/stores/report.store';
import { MappingService } from 'src/app/services/mapping.service';
import { ConvertService } from 'src/app/services/convert.service';
import { MatDialog } from '@angular/material';
import { ReportReceiptDialogComponent } from 'src/app/components/report-receipt-dialog/report-receipt-dialog.component';
import { ReportReceiptSummaryDialogComponent } from 'src/app/components/report-receipt-summary-dialog/report-receipt-summary-dialog.component';
import { ReportShiftSummaryDialogComponent } from 'src/app/components/report-shift-summary-dialog/report-shift-summary-dialog.component';
import { SCHOOL } from 'src/app/dummy/config';

@Component({
  selector: 'app-daily-shift-listings',
  templateUrl: './daily-shift-listings.component.html',
  styleUrls: ['./daily-shift-listings.component.scss']
})
export class DailyShiftListingsComponent implements OnInit {
  tabs = tabs.reportFilterBy;
  school=SCHOOL

  form: FormGroup;
  fromDate: AbstractControl;
  toDate: AbstractControl;

  fromDateTime: any;
  toDateTime: any;

  type: string;
  constructor(
    private fb: FormBuilder,
    private ps: PrintService,
    public env: Environment,
    private route: ActivatedRoute,
    public store: Report,
    public dialog: MatDialog
  ) { }

  print() {
    this.ps.print("#print", "a4");
  }

  ngOnInit() {
    this.buildForm();
    this.route.params.forEach(param => {
      this.type = param["id"];
      const fromDate = MappingService.fromDateFilter(this.type);
      const toDate = MappingService.toDateFilter(this.type);
      this.form.patchValue({
        fromDate: fromDate,
        toDate: toDate
      });
      this.getList(fromDate, toDate);
      if (this.type === "custom") {
        this.fromDate.enable();
        this.toDate.enable();
      } else {
        this.fromDate.disable();
        this.toDate.disable();
      }
    });
  }

  getList(fromDate, toDate) {
    this.env.getUser(user => {
      if (user)
        this.store.fetchDailyShiftListing(ConvertService.toDateKey(fromDate), ConvertService.toDateKey(toDate), user.key);
    })
  }

  buildForm(): void {
    this.form = this.fb.group({
      fromDate: [null, Validators.required],
      toDate: [null, Validators.required],
    });

    this.fromDate = this.form.controls["fromDate"];
    this.toDate = this.form.controls["toDate"];
  }

  _onPress(f: any) {
    if (this.form.valid) {
      const { fromDate, toDate } = f;
      this.getList(fromDate, toDate);
    }
  }

  _onReceiptListing(item) {
    let dialogRef = this.dialog.open(ReportReceiptDialogComponent, {
      data: item,
      width: '90vw',
      height: '80vh',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => { });
  }

  _onReceiptSummary(item) {
    let dialogRef = this.dialog.open(ReportReceiptSummaryDialogComponent, {
      data: item,
      width: '90vw',
      height: '80vh',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => { });
  }

  _onShiftSummary(item) {
    let dialogRef = this.dialog.open(ReportShiftSummaryDialogComponent, {
      data: item,
      width: '90vw',
      height: '80vh',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => { });
  }

}
